import React from 'react';
import styled from 'styled-components';
import GlobalStyle from '../../styles/GlobalStyle';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import { Outlet } from 'react-router-dom';

const LayoutWrapper = styled.div`
    min-height: 100vh;
    display: flex;
    flex-direction: column;
`;

const MainContent = styled.main`
    flex: 1;
    position: absolute;
    max-width: 800px;
    top: 5%;
    width: 100%;
    left: 50%;
    transform: translateX(-50%);
    z-index: 5;
`;

const SharedLayout = () => {
    return (
        <LayoutWrapper>
            <GlobalStyle />
            <Header />
            <MainContent role="main" id="main-content">
                <Outlet />
            </MainContent>
            <Footer />
        </LayoutWrapper>
    );
};

export default SharedLayout;
